// Thin wrapper around window.fbq so components don't break if pixel isn't loaded
export const fbqTrack = (event, params) => {
  if (typeof window === 'undefined') return;
  if (typeof window.fbq !== 'function') return;
  try {
    if (params) window.fbq('track', event, params);
    else window.fbq('track', event);
  } catch (e) {
    // swallow — analytics should never break the funnel
    // eslint-disable-next-line no-console
    console.warn('fbq error', e);
  }
};
